export default __webpack_public_path__ + "static/media/prana06.1a20f37b.JPG";